import React, { Component } from "react"
import Typography from "@mui/material/Typography"
import { sanitizeYaml } from "../../utilities"
import linkifyHtml from "linkify-html"

export default class DifferentClues extends Component {
  render() {
    const { clues, text } = this.props

    return (
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          maxWidth: "min(960px, calc(100% - 64px))",
          padding: "32px",
          maxHeight: "calc(100% - 64px)",
          overflow: "auto",
        }}
      >
        {text && (
          <div
            style={{
              textAlign: "center",
              textTransform: "none",
              padding: "32px 48px",
              borderRadius: "24px",
              background: "rgba(255, 255, 255, .8)",
              backdropFilter: "blur(16px)",
            }}
          >
            <Typography
              variant="h3"
              dangerouslySetInnerHTML={{
                __html: linkifyHtml(sanitizeYaml(sanitizeYaml(text)), {
                  target: "_blank",
                  attributes: {
                    class: "underlineOnHover",
                  },
                }),
              }}
            />
          </div>
        )}
        {clues.map((clue) => (
          <div
            style={{
              textAlign: "center",
              textTransform: "none",
              marginTop: "16px",
              padding: "32px 48px",
              borderRadius: "24px",
              background: "rgba(255, 255, 255, .8)",
              backdropFilter: "blur(16px)",
            }}
          >
            <Typography
              variant="h3"
              style={{
                fontWeight: 300,
              }}
              dangerouslySetInnerHTML={{
                __html: linkifyHtml(sanitizeYaml(clue), {
                  target: "_blank",
                  attributes: {
                    class: "underlineOnHover",
                  },
                }),
              }}
            />
          </div>
        ))}
      </div>
    )
  }
}
